import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Author, TimelinePollResultTimelineItemType } from "@teammood/timeline";
import { PollType } from "../../polls.type";
import { PollResult, PollResultValue } from "../../../timeline/timeline-item/poll-result/poll-result.type";
import { TranslateService } from "@ngx-translate/core";
import { PollSetupService } from "../../polls-setup.service";
import { tap } from "rxjs";

@Component({
    selector: 'poll-results-dialog',
    templateUrl: './poll-results-dialog.component.html',
    styleUrls: ['./poll-results-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PollResultsDialogComponent implements OnInit {
    
    protected poll: PollDetails;
    protected showMore = false;
    protected loading: boolean = true;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: PollDetailsData,
        public dialogRef: MatDialogRef<PollResultsDialogComponent>,
        protected translate: TranslateService,
        private pollSetupService: PollSetupService,
    ) { }

    ngOnInit(): void {
        this.pollSetupService.getPollDetails(this.data.pollOccurrenceId).pipe(
            tap((pollDetails: PollDetails) => {
                this.poll = pollDetails;
                this.loading = false;
            }),
        ).subscribe();
    }
    
    close() {
        this.dialogRef.close();
    }

    convertPollTypeIntoTimelineItemType(pollType: PollType): TimelinePollResultTimelineItemType {
        if (pollType) {
            switch (pollType) {
                case 'ClosedQuestion':
                    return 'closedQuestionResultItem';
                case 'AgreeDisagreeQuestion':
                    return 'agreeDisagreeQuestionResultItem';
                case 'ScaleQuestion':
                    return 'scaleQuestionResultItem';
                case 'FiveStarsQuestion':
                    return 'fiveStarsQuestionResultItem';
                default:
                    console.error('Unknown poll type');
            }
        }
    }

    protected commentCount(pollResults: PollResultValue[]): number {
        if (pollResults) {
            return pollResults.flatMap(pollResult => pollResult.comments).length;
        }
        return 0;
    }

    protected hasComments(pollResults: PollResultValue[]): boolean {
        if (pollResults) {
            return this.commentCount(pollResults) > 0;
        }
        return false;
    }
}

interface PollDetailsData {
    pollOccurrenceId: string,
}

export interface PollDetails {
    label: string,
    displayAuthor: boolean,
    author?: Author,
    startDate: Date,
    endDate: Date,
    teams: PollInTeamResults[],
    aggregatedResults: PollResults,
}

export class PollResults {
    pollId: string;
    pollType: PollType;
    results: PollResult;
    participation: number;
    teamsSize: number;
}

export class PollInTeamResults {
    teamId: string;
    teamName: string;
    pollId: string;
    timelineItemLink?: string;
    participation: number;
    pollType: PollType;
    results: PollResult;
    teamsSize: number;
}
